import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "w-full tw matters-page bg-white print:overflow-hidden",
  style: {"position":"absolute","left":"0px"}
}
const _hoisted_2 = { class: "container tw color-unset lineheight-unset flex flex-col" }
const _hoisted_3 = { class: "flex h-full w-full" }
const _hoisted_4 = {
  key: 0,
  class: "px-4 pb-4 w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-8 w-full text-lg text-center font-semibold text-gray-800"
}

import { ref, onMounted } from 'vue';
import type { PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import type { UiRouterState } from '@/services/RouteService/UiRouterState';
import MattersTable from './MattersTable.vue';
import MattersUpgradeNotice from './components/MattersUpgradeNotice.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MattersPage',
  props: {
  state: { type: Object as PropType<UiRouterState>, required: false },
},
  setup(__props) {

const props = __props;

const meStore = useMeStore();
const { permissions, features } = storeToRefs(meStore);
const meLoaded = ref(false);

onMounted(async () => {
  await meStore.getMe();

  // Feature-flagged route (sc-46278): /matters is the rewritten Matters list.
  // Accounts without fizzyLiftingDrink enabled are sent to the current
  // experience at matters-next instead.
  if (!features.value?.fizzyLiftingDrink) {
    props.state?.go('matters-next', props.state?.params);
    return;
  }

  meLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (meLoaded.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(permissions)?.matters?.create)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(MattersUpgradeNotice),
                    _createVNode(MattersTable, { state: __props.state }, null, 8, ["state"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, " You do not have permission to view this page! "))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})